export default {
  "HitPaw Online Audio Extractor": "HitPaw Çevrimiçi Ses Çıkarıcı",
  "Extract sound from videos with ease.": "Videolardan kolayca ses çıkarın.",
  "Select Audio Format": "Ses Biçimini Seçin",
  "Extract Audio": "Ses Çıkar",
  "Extracting Audio": "Ses Çıkarma",
  "Extracted Successfully": "Başarıyla Çıkarıldı",
  "Extract New": "Yeni Çıkar",
  "Extraction Failed": "Çıkarma Başarısız",
  "Format": "Biçim",
};
